import type { Env } from '../types';

const env: Env = {
  STAGE: 'dev',

  API_BASE_URL: 'https://1vti3u2qk1.execute-api.eu-west-1.amazonaws.com',

  RECAPTCHA_V3_SITE_KEY: '6LfZqq0fAAAAAIxbz8FaOa4SKQeefeISd6TCN6AN',
};

export default env;
